import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { timeNumber2Date, getDate } from '../utils/date';
let CapacityDetailService = class CapacityDetailService {
    constructor(capacityDetailApi, productService, i18n) {
        this.capacityDetailApi = capacityDetailApi;
        this.productService = productService;
        this.i18n = i18n;
        this.getProductionProducts = this.productService.getProductionProducts;
        this.getAccountCapacity = this.capacityDetailApi.getAccountCapacity;
        this.getCompanyCapacity = this.capacityDetailApi.getCompanyCapacity;
    }
    showDuring(item) {
        const begin = getDate(item.begin_at_value) || timeNumber2Date(item.begin_at, 'YYYY-MM-DD');
        const end = getDate(item.end_at_value) || timeNumber2Date(item.end_at, 'YYYY-MM-DD');
        return this.i18n.t('backoffice.common.timeRange', {
            begin, end,
        });
    }
};
CapacityDetailService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CapacityDetailApi)),
    __param(1, inject(Symbols.ProductService)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CapacityDetailService);
export { CapacityDetailService };
